import React, { useState, useCallback, useMemo, useContext, useEffect } from 'react'
import { formatOccupantsShort } from 'lib/occupancyUtils'
import { StandaloneFlightMenu } from 'components/Flights/FlightsSearch/SearchWidget/SearchWidget'
import { FlightSearchWidgetActions } from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateReducer'

import TravellerDropdown from './TravellerDropdown'
import FlightSearchMenuDesktop from '../FlightSearchMenu/FlightSearchMenuDesktop'
import Breakpoint from 'components/Common/Breakpoint'
import FlightSearchMenu from '../FlightSearchMenu/FlightSearchMenu'
import TravellerInputToogle from './TravellerInputToogle'
import FlightSearchWidgetStateContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateContext'
import FlightSearchWidgetDispatchContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetDispatchContext'

interface Props {
  className?: string;
  useOnlyMobile?: boolean
}

const TravellerInput = ({ className, useOnlyMobile }: Props) => {
  const state = useContext(FlightSearchWidgetStateContext)
  const dispatch = useContext(FlightSearchWidgetDispatchContext)

  const { occupants, activeMenu } = state
  const [updatedOccupants, setUpdatedOccupants] = useState(occupants)
  const travellerLabel = useMemo(() => formatOccupantsShort(updatedOccupants), [updatedOccupants])

  useEffect(() => {
    setUpdatedOccupants(occupants)
  }, [occupants])

  const setActiveMenu = useCallback((activeMenu: StandaloneFlightMenu) => {
    dispatch({ type: FlightSearchWidgetActions.SET_ACTIVE_MENU, activeMenu })
  }, [dispatch])

  const onApply = useCallback(() => {
    if (!updatedOccupants.childrenAge?.some(age => age === -1)) {
      setActiveMenu(null)
    }
    dispatch({ type: FlightSearchWidgetActions.SET_OCCUPANTS, occupants: updatedOccupants })
  }, [updatedOccupants, dispatch, setActiveMenu])

  const onCancel = useCallback(() => {
    setActiveMenu(null)
    setUpdatedOccupants(occupants)
  }, [setActiveMenu, setUpdatedOccupants, occupants])

  const handleOpen = useCallback(() => {
    setActiveMenu(StandaloneFlightMenu.occupants)
  }, [setActiveMenu])

  return (
    <div className={className}>
      <TravellerInputToogle occupants={occupants} handleOpen={handleOpen} />

      {!useOnlyMobile && (
        <Breakpoint min="sm">
          <FlightSearchMenuDesktop
            open={activeMenu === StandaloneFlightMenu.occupants}
            onCancel={onCancel}
            onApply={onApply}
            travellerLabel={travellerLabel}
          >
            <TravellerDropdown
              occupants={updatedOccupants}
              setOccupants={setUpdatedOccupants}
            />
          </FlightSearchMenuDesktop>
        </Breakpoint>
      )}

      <Breakpoint max={useOnlyMobile ? undefined : 'xs'}>
        <FlightSearchMenu
          open={activeMenu === StandaloneFlightMenu.occupants}
          title="Travellers"
          travellerLabel={travellerLabel}
          onApply={onApply}
          onCancel={onCancel}
        >
          <TravellerDropdown
            occupants={updatedOccupants}
            setOccupants={setUpdatedOccupants}
          />
        </FlightSearchMenu>
      </Breakpoint>
    </div>
  )
}

export default TravellerInput
